import request from "@/api/axios";

// 获取首页轮播信息
export function getHomeList(data) {
	return request({
		url: `/index/pic`,
		method: 'get',
		data
	});
}
// 获取品牌故事 信息
export function getBrandData(data) {
	return request({
		url: `/brand/articles`,
		method: 'get',
		data
	});
}
// 联系我们 
export function postContactUs(data) {
	return request({
		url: `contact/us`,
		method: 'post',
		data
	});
}
